<div class="custom-field" [id]="field?.fieldColumn" fxLayout="column" fxLayoutAlign="start stretch">
	<div class="quill-editor">
		<div fxLayout="row" fxLayoutAlign="start start">
			<mat-label [ngClass]="{error: (control.errors && control.touched)}"
				*ngIf="![null, undefined, ''].includes(field.fieldCaption) && field?.additionalMetaData?.showLabel">
				{{field.fieldCaption}} <span *ngIf="field?.isRequired">*</span></mat-label>
			<ng-container *ngIf="field?.helpLine?.length">
				<app-help-line [helpLineData]="field.helpLine" fxLayout="row" fxLayoutAlign="start start"
					(helpLineEmit)="helpLineData($event)"></app-help-line>
			</ng-container>
		</div>
		<div fxLayout="column" fxLayoutAlign="start stretch">
			<quill-editor [placeholder]="field.fieldPlaceholder" [formControl]="control" [style]="editorialStyle"
				[modules]="quileditorConfig" (onContentChanged)="onChange($event)" bounds="self"
				(onEditorCreated)="onReady($event)" (onSelectionChanged)="onEditorChange($event)">
			</quill-editor>
			<!-- <div id="toolbar-container">
				<span class="ql-formats">
					<select class="ql-font">
						<option selected>Sans Serif</option>
						<option value="inconsolata">Inconsolata</option>
						<option value="roboto">Roboto</option>
						<option value="mirza">Mirza</option>
						<option value="arial">Arial</option>
					</select>
				</span>
			</div> -->

			<mat-hint *ngIf="(control.untouched || control.valid) && ![null, undefined, ''].includes(field.fieldHelpText)"
				[@slide]="{ value: 'rightIn', params: { colorFrom:'rgba(0, 0, 0, 0.6)', translateFrom: 'translateY(20%)',inTime:'200ms' }}">
				{{field.fieldHelpText}}</mat-hint>
			<mat-error *ngIf="control.errors && control.touched"
				[@slide]="{ value: 'rightIn', params: { colorFrom:'#ff5722', translateFrom: 'translateY(20%)',inTime:'200ms' }}"
				[innerHtml]="controlFunctions.validationMsg(control, field)">
			</mat-error>
		</div>
	</div>
	<ng-container *ngIf="loader">
		<div fxLayoutAlign="center center" class="SVG-loader" title="0">
			<svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
				x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40"
				xml:space="preserve">
				<path opacity="0.2" fill="#000"
					d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
                      s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
                      c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z" />
				<path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
                      C22.32,8.481,24.301,9.057,26.013,10.047z">
					<animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 20 20" to="360 20 20"
						dur="0.5s" repeatCount="indefinite" />
				</path>
			</svg>
		</div>
	</ng-container>
</div>
